import { render, staticRenderFns } from "./CustomLink.vue?vue&type=template&id=54442bbb&"
import script from "./CustomLink.vue?vue&type=script&lang=js&"
export * from "./CustomLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54442bbb')) {
      api.createRecord('54442bbb', component.options)
    } else {
      api.reload('54442bbb', component.options)
    }
    module.hot.accept("./CustomLink.vue?vue&type=template&id=54442bbb&", function () {
      api.rerender('54442bbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomLink.vue"
export default component.exports